/**
 * Match admin session-list order.
 *
 * SB-9083: admins can drag subsessions into an explicit order, persisted as
 * `subsession_order` (1..N) and served by the embed feed. That wins when set;
 * children with no order (legacy parents, or ones attached after the last
 * reorder) fall back to `subsession_number`, then `starts_at`, then
 * `friendly_id` — the pre-SB-9083 order — and sort after the ordered ones.
 * Untimed children often share a null starts_at (SB-8291 / event 6150).
 *
 * @param {Array<{ subsession_order?: number|null, subsession_number?: number|null, starts_at?: string|null, friendly_id?: string|number|null }>} subsessions
 * @returns {typeof subsessions}
 */
export function sortSubsessions(subsessions = []) {
  return [...subsessions].sort((a, b) => {
    const ao = a.subsession_order == null ? Number.POSITIVE_INFINITY : Number(a.subsession_order);
    const bo = b.subsession_order == null ? Number.POSITIVE_INFINITY : Number(b.subsession_order);
    if (ao !== bo) return ao - bo;
    const an = a.subsession_number == null ? Number.POSITIVE_INFINITY : Number(a.subsession_number);
    const bn = b.subsession_number == null ? Number.POSITIVE_INFINITY : Number(b.subsession_number);
    if (an !== bn) return an - bn;
    const at = a.starts_at || '';
    const bt = b.starts_at || '';
    if (at !== bt) return at < bt ? -1 : 1;
    const af = String(a.friendly_id ?? '');
    const bf = String(b.friendly_id ?? '');
    return af.localeCompare(bf, undefined, { numeric: true });
  });
}
